export function reg_one(value){
    const regex1 = /^[a-zA-Z0-9]{21}$/;//不区分大小写英文与数字结合，21位
    const regex2 = /^\d{16,20}$/;//纯数字，16-20位
    if(regex1.test(value) || regex2.test(value)){
        return true
      }else{
        return false
      }
}

export function reg_two(value){
  const regex1 = /^[a-zA-Z0-9]{21}$/;//不区分大小写英文与数字结合，21位
  if(regex1.test(value)){
      return true
    }else{
      return false
    }
}

export function validateSpecialAndHttp(value) {
  // const regexSpecial = /[^\w\u4e00-\u9fa5]/;  // 允许字母、数字、中文字符
  const regexHttp = /http[s]?:\/\//;  // 检查是否包含 http 或 https 协议
  const regexPureNumber = /^\d+$/;  // 检查是否为纯数字

  // 判断字符串是否包含特殊字符或 http/https 协议，或者是纯数字
  if (regexHttp.test(value)) {
    return false;
  } else if (regexPureNumber.test(value)) {
    return false;
  } else {
    return true;
  }
}

export function validateURL(value) {
  if (value=='') {
    return true;
  }
  // 正则表达式用于验证网址格式
  const regexURL = /\./;

  // 检查网址格式
  return regexURL.test(value);
}

export function validateEmail(value) {
  // 正则表达式用于验证邮箱格式
  const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  // 检查邮箱格式
  return regexEmail.test(value);
}

export function validateFiveDigitNumber(value) {
  // 正则表达式：匹配仅包含 5 位数字的字符串
  const regex = /^\d{5}$/;

  // 使用正则验证输入值
  return regex.test(value);
}

export function checkIsIPhone() {
  const userAgent = navigator.userAgent;
  return /iPhone/i.test(userAgent);
}